import { useCallback } from 'react';

import { useRequirementState } from './useRequirementState';

export const useRequirementMaxCountState = () => {
  const {
    requirement: { maxMatch: requirementMaxCount },
    setRequirement,
  } = useRequirementState();
  const setRequirementMaxCount = useCallback(
    (newMaxCount?: number) =>
      setRequirement((requirement) => ({ ...requirement, maxMatch: newMaxCount })),
    [setRequirement],
  );
  return {
    requirementMaxCount,
    setRequirementMaxCount,
  };
};
